/**
 * Zentrale Debug-Konfiguration für die gesamte Anwendung
 * 
 * In Production (Vercel) automatisch deaktiviert
 * Für lokales Debugging: REACT_APP_DEBUG=true in .env.local setzen
 */

const isProduction = process.env.NODE_ENV === 'production';
const debugEnabled = process.env.REACT_APP_DEBUG === 'true';

export const DEBUG = {
  // Globales Debug-Flag (sollte in Production immer false sein)
  ENABLED: !isProduction && debugEnabled,
  
  // Spezifische Debug-Flags für verschiedene Bereiche
  API: !isProduction && (process.env.REACT_APP_DEBUG_API === 'true' || debugEnabled),
  AUTH: !isProduction && (process.env.REACT_APP_DEBUG_AUTH === 'true' || debugEnabled),
  COMPONENTS: !isProduction && (process.env.REACT_APP_DEBUG_COMPONENTS === 'true' || debugEnabled),
  ROUTING: !isProduction && (process.env.REACT_APP_DEBUG_ROUTING === 'true' || debugEnabled),
};

/**
 * Debug-Wrapper-Funktionen
 * Verwende diese statt console.log direkt
 */
export const debugLog = {
  api: (...args) => DEBUG.API && console.log(...args),
  auth: (...args) => DEBUG.AUTH && console.log(...args),
  component: (...args) => DEBUG.COMPONENTS && console.log(...args),
  routing: (...args) => DEBUG.ROUTING && console.log(...args),
  error: (...args) => console.error(...args), // Errors immer loggen
  warn: (...args) => console.warn(...args),   // Warnings immer loggen
};

export default DEBUG;
